export type VerificationDocumentLike = {
  type?: string | null;
};

export type ShortlistTutorStatus = 'pending' | 'contacting' | 'accepted' | 'declined';

export type TutorShortlistResponseStatus = Extract<ShortlistTutorStatus, 'accepted' | 'declined'>;

export type MatchSource = 'smart' | 'manual' | 'parent_wishlist' | 'application';

export type TutorVerificationLike = {
  verificationStatus?: string | null;
  verificationDocuments?: VerificationDocumentLike[] | null;
};

type IsFullyVerifiedOptions = {
  statusOverride?: string | null;
};

function hasDocumentType(
  profile: Pick<TutorVerificationLike, 'verificationDocuments'> | null | undefined,
  types: string[]
): boolean {
  return !!profile?.verificationDocuments?.some((doc) => doc.type && types.includes(doc.type));
}

export function hasIdentityDocument(
  profile: Pick<TutorVerificationLike, 'verificationDocuments'> | null | undefined
): boolean {
  return hasDocumentType(profile, ['identity']);
}

export function isFullyVerified(
  profile: TutorVerificationLike | null | undefined,
  options?: IsFullyVerifiedOptions
): boolean {
  const verificationStatus = options?.statusOverride ?? profile?.verificationStatus;

  return verificationStatus === 'approved' && hasIdentityDocument(profile);
}
